import { useMutation } from "@tanstack/react-query";
import fetchData from "../fetcher";
import { CreateOrganizationPayload, CreateOrganizationResponse } from "./types";

export const isOrganizationNameAlreadyExists = (payload: unknown): boolean => {
    if (!payload || typeof payload !== "object") return false;

    const errors = (payload as { errors?: Record<string, unknown> }).errors;
    if (errors && typeof errors === "object" && "name_already_exists" in errors) {
        return true;
    }

    const message =
        (payload as { message?: unknown }).message ??
        (payload instanceof Error ? payload.message : undefined);
    return typeof message === "string" && /organization with same name already exists/i.test(message);
};

export const useCreateOrganization = () => {
    const { mutate: createOrganization, mutateAsync: createOrganizationAsync, error, isError, isPending, isSuccess } = useMutation({
        mutationKey: ["create-organization"],
        mutationFn: async (body: CreateOrganizationPayload) => {
            try {
                return await fetchData<CreateOrganizationResponse>("/iam/v4/iam/organizations/create", {
                    method: "POST",
                    body,
                });
            } catch (error) {
                const data = (error as { data?: CreateOrganizationResponse })?.data;
                if (data && typeof data === "object" && "isSuccess" in data) {
                    return data;
                }
                throw error;
            }
        },
    });

    return { createOrganization, createOrganizationAsync, error, isError, isPending, isSuccess }
};
